import React, { useEffect, useState } from "react";
import axios from "axios";
import { getBaseUrl } from "../../utils";
import { useNavigate } from "react-router-dom";
const FormFinal = ({ nextStep, handleFormData, values, prevStep }) => {
    const baseUrl = getBaseUrl();
    const token = localStorage.getItem("userToken");

    const [profileData, setProfileData] = useState(null);
    const [classList, setclassList] = useState([]);



    async function fetchProfileData() {
        try {
            const response = await axios.get(baseUrl + "user_api/getProfileData", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data.status) {
                console.log("response--------->", response.data.results);
                setProfileData(response.data.results);
            } else {
                console.log("Failed to fetch profile data.");
            }
        } catch (error) {
            console.log("Error fetching profile data: " + error.message);
        } finally {
            //setLoading(false);
        }
    }


    useEffect(() => {
        if (!token) {
            console.log("Token is missing. Please login again.");
            //setLoading(false);
            return;
        }
        fetchProfileData();
    }, [token]);

    const [formData, setFormData] = useState({
        address: "",
    });

    const handleFormDataNEW = (input) => (e) => {
        const value = e.target?.value;
        setFormData((prevState) => ({
            ...prevState,
            [input]: value,
        }));
        // Trigger pincode API call if the pincodeName is updated
        if (input === "pincodeName" && value.length === 6) {
            fetchLocationData(value);
        }
    };

    const fetchLocationData = async (pincodeName) => {
        try {
            const response = await axios.get(`${baseUrl}user_api/locationList?pincodeName=${pincodeName}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response.data.status && response.data.results.length > 0) {
                const location = response.data.results[0];
                setFormData((prevState) => ({
                    ...prevState,
                    state: location.stateInfo[0]?.name || "",
                    city: location.cityInfo[0]?.name || "",
                    stateId: location.stateInfo[0]?._id || "",
                    cityId: location.cityInfo[0]?._id || "",
                    pincodeId: location._id || "",
                }));
            } else {
                setFormData((prevState) => ({
                    ...prevState,
                    state: "",
                    city: "",
                    stateId: "",
                    cityId: "",
                    pincodeId: "",
                }));
                alert("No location data found for the provided pincode.");
            }
        } catch (error) {
            console.error("Error fetching location data:", error.message);
        }
    };
    const navigate = useNavigate();
    const FormOneSubmit = async (e) => {
        e.preventDefault();
        console.log("formData---FormOneSubmit->", formData);

        const formDataToSend = new FormData();
        if (formData.address) formDataToSend.append("address", formData.address);
        if (formData.stateId) formDataToSend.append("stateId", formData.stateId);
        if (formData.cityId) formDataToSend.append("cityId", formData.cityId);
        if (formData.pincodeId) formDataToSend.append("pincodeId", formData.pincodeId);

        if (formData.profile_img) {
            formDataToSend.append("profile_img", formData.profile_img);
        } else {
            formDataToSend.append("profile_img", "");
        }

        try {
            const response = await axios.patch(baseUrl + "user_api/profileUpdate", formDataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log("API Response:", response.data);
            alert("Profile Update successfully!");
            navigate("/Dashboard");
        } catch (error) {
            console.error("Error in API call:", error);
        }
    };


    useEffect(() => {
        if (profileData) {
            setFormData((prevState) => ({
                ...prevState,
                address: profileData.address || "",
                state: profileData.stateDetails?.name || "",
                stateId: profileData.stateDetails?._id || "",
                city: profileData.cityDetails?.name || "",
                cityId: profileData.cityDetails?._id || "",
                pincodeName: profileData.pincodeDetails?.name || "",
                pincodeId: profileData.pincodeDetails?._id || "",
            }));
        }
    }, [profileData]);


    // useEffect(() => {
    //     const token = localStorage.getItem("userToken");
    //     if (token) {
    //         navigate("/dashboard"); // Redirect to dashboard if token exists
    //     }
    // }, [navigate]);


    const isFormValid = formData.address && formData.stateId && formData.cityId && formData.pincodeId;

    //    useEffect(() => {
    //            const token = localStorage.getItem("userToken");
    //            if (token && isFormValid) {
    //                navigate("/dashboard"); // Redirect to dashboard if token exists
    //            }
    //        }, [navigate,isFormValid]);
    return (
        <div>
            <section className="pt-[20px] px-4 md:px-0">
                <div className="max-w-[1300px] mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-5 bg-[#F2F2F2] px-4 md:px-[30px] pt-[40px] pb-[40px] rounded-[20px] gap-6">
                        {/* Sidebar Left (5-column layout, 2 columns used on desktop) */}
                        <div className="md:col-span-2 h-auto md:h-[700px]">
                            <div className="md:mt-0 mt-6">
                                <div className="bg-[#FFFFFF] pt-[60px] p-8 rounded-[15px] h-full">
                                    <div className="flex items-center justify-center pb-[50px] ">
                                        <img
                                            src="/assates/Logo__newimage.png"
                                            alt="images"
                                            className="w-[160px]"
                                        />
                                    </div>
                                    <div className="h-full">
                                        <div className="flex gap-2">
                                            <div className="flex flex-col items-center">
                                                <div className="bg-[#F4F4F4] w-[50px] h-[50px] flex items-center justify-center rounded-[10px]">
                                                    <img src="/assates/father_name.svg" alt="images" />
                                                </div>
                                                <div className="line h-[50px] w-[2px] bg-[#E4E4E4]" />
                                            </div>
                                            <div>
                                                <h4 className="font-[700] Paragraph__etxt ">
                                                    Your Details
                                                </h4>
                                                <p className="Paragraph__etxt font-[300]">
                                                    Provide your details to create
                                                    your profile.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex gap-2">
                                            <div className="flex flex-col items-center">
                                                <div className="bg-[#F4F4F4] w-[50px] h-[50px] flex items-center justify-center rounded-[10px]">
                                                    <img src="/assates/Eduction.svg" />    
                                                </div>
                                                <div className="line h-[50px] w-[2px] bg-[#E4E4E4]" />
                                            </div>
                                            <div>
                                                <h4 className="font-[700] Paragraph__etxt">
                                                    Educational Details
                                                </h4>
                                                <p className="Paragraph__etxt font-[300]">
                                                    Fill your Educational Details
                                                </p>
                                            </div>
                                        </div>

                                        <div className="flex gap-2">
                                            <div className="flex flex-col items-center">
                                                <div className="bg-[#F4F4F4] w-[50px] h-[50px] flex items-center justify-center rounded-[10px]">
                                                    <i class="ri-user-location-fill text-[22px] text-black"></i>
                                                </div>
                                            </div>
                                            <div className="">
                                                <h4 className="font-[700] Paragraph__etxt">
                                                    Address
                                                </h4>
                                                <p className="Paragraph__etxt font-[300]">
                                                    Complete Address, City, State, Pincode
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* Form Right (5-column layout, 3 columns used on desktop) */}
                        <div className="md:col-span-3 pt-[40px] md:pt-[70px] Paragraph__etxt flex flex-col justify-between relative">
                            <button
                                className="absolute right-0  hover:bg-gray-300 rounded-full p-2 flex items-center justify-center w-10 h-10"
                                onClick={() => prevStep()}
                            >
                                <img src="/assates/left_arrow.png" alt="Back" className="w-3" />
                            </button>

                            <div>
                                <h3 className="Header__text font-[700]">Address</h3>
                                <p className="Paragraph__etxt font-[500] pt-1 pb-4">
                                    Fill your Address Details
                                </p>

                                <form onSubmit={FormOneSubmit}>
                                    <div className="space-y-[30px]">
                                        {/* Row 1: Address & Pincode */}
                                        <div className="flex flex-col md:flex-row gap-[20px]">
                                            {/* Address */}
                                            <div className="flex bg-white pl-3 w-full rounded-[10px] items-center">
                                                <div>
                                                    <i className="ri-user-location-fill"></i>
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <input

                                                        type="text"
                                                        name="address"
                                                        required
                                                        placeholder="#545, Rishi Nagar, 3rd Floor"
                                                        className="w-full py-3"
                                                        style={{ outline: "none" }}
                                                        onChange={handleFormDataNEW("address")}
                                                        value={formData.address}
                                                    />
                                                </div>
                                            </div>

                                            {/* Pincode */}
                                            <div className="flex bg-white pl-3 w-full rounded-[10px] items-center">
                                                <div>
                                                    <i className="ri-map-pin-range-fill"></i>
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <input
                                                        type="text"
                                                        name="pincodeName"
                                                        required
                                                        placeholder="110034"
                                                        className="w-full py-3"
                                                        style={{ outline: "none" }}
                                                        onChange={handleFormDataNEW("pincodeName")}
                                                        value={formData.pincodeName}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Row 2: State & City */}
                                        <div className="flex flex-col md:flex-row gap-[20px]">
                                            {/* State */}
                                            <div className="flex bg-white pl-3 w-full rounded-[10px] items-center">
                                                <div>
                                                    <img src="/assates/House.svg" alt="state" />
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <input
                                                        type="text"
                                                        name="State"
                                                        required
                                                        placeholder="State"
                                                        className="w-full py-3"
                                                        style={{ outline: "none" }}
                                                        value={formData.state}
                                                    />
                                                </div>
                                            </div>

                                            {/* City */}
                                            <div className="flex bg-white pl-3 w-full rounded-[10px] items-center">
                                                <div>
                                                    <img src="/assates/States.svg" alt="city" />
                                                </div>
                                                <div className="w-full pl-2 pr-2">
                                                    <input
                                                        type="text"
                                                        name="City"
                                                        required
                                                        placeholder="City"
                                                        className="w-full py-3"
                                                        style={{ outline: "none" }}
                                                        value={formData.city}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Submit Button */}
                                    <div className="flex justify-end mt-8">
                                        <button
                                            type="submit"
                                            className={`w-full md:w-[350px] h-[50px] rounded-[15px] text-white Paragraph__etx ${isFormValid ? "bg-gray-900" : "bg-[#B4B4B4]"
                                                }`}
                                        >
                                            Continue
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default FormFinal;
